import urls from "@/constants/urls";
import axios from "axios";
import { ref } from "vue";

async function getProtectedCampaignRulesList(orgId, cId, params) {
  const url = urls.campaignRules(orgId, cId);
  const { data } = await axios.get(url, { params });

  return {
    data,
    count: data?.meta?.total || 0,
  };
}

async function putProtectedCampaignRules(orgId, cId, id, data, params) {
  const url = urls.campaignRules(orgId, cId) + `/${id}`;
  const { data: response } = await axios.put(url, data, { params });

  return {
    data: response,
  };
}

async function deleteProtectedCampaignRules(orgId, cId, id, params) {
  const url = urls.campaignRules(orgId, cId) + `/${id}`;
  const { data: response } = await axios.delete(url, { params });

  return {
    data: response,
  };
}

async function postProtectedCampaignRules(orgId, cId, data, params) {
  const url = urls.campaignRules(orgId, cId);
  const { data: response } = await axios.post(url, data, { params });

  return {
    data: response,
  };
}

export function useCampaignRules() {
  const orgId = localStorage.getItem("orgId");

  const list = ref([]);
  const total = ref(0);
  const loading = ref(false);

  async function fetchOrgCampaignRulesList(cId, params) {
    loading.value = true;

    try {
      const { data, count } = await getProtectedCampaignRulesList(orgId, cId, params);
      list.value = data;
      total.value = count;

      return data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  async function createOrgCampaignRules(cId, payload, params) {
    loading.value = true;

    try {
      const { data } = await postProtectedCampaignRules(orgId, cId, payload, params);

      return data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  async function updateOrgCampaignRules(cId, id, payload, params) {
    loading.value = true;

    try {
      const { data } = await putProtectedCampaignRules(orgId, cId, id, payload, params);

      return data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  async function deleteOrgCampaignRules(cId, id, params) {
    loading.value = true;

    try {
      const { data } = await deleteProtectedCampaignRules(orgId, cId, id, params);

      return data;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return {
    list,
    total,
    loading,
    fetchOrgCampaignRulesList,
    deleteOrgCampaignRules,
    createOrgCampaignRules,
    updateOrgCampaignRules,
  };
}
